import { APITruck } from './truck.types';

export class APIInvoice {
  id: string;
  invoiceNumber: string;
  customerRef: string;
  status: string;
  structuredComment: string;

  constructor(data: any) {
    this.id = data.id;
    this.invoiceNumber = data.invoiceNumber || '';
    this.customerRef = data.customerRef || '';
    this.status = data.status || '';
    this.structuredComment = data.structuredComment || '';
  }
}

export class APILocation {
  id: string;
  name: string;
  street: string;
  streetNumber: string;
  postalCode: string;
  country: string;
  language: string;
  latitude: number | null;
  longitude: number | null;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.street = data.street;
    this.streetNumber = data.streetNumber;
    this.postalCode = data.postalCode;
    this.country = data.country;
    this.language = data.language;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }
}

export class APIOrderLineStop {
  id: string;
  lineId: string;
  stopNumber: number;
  type: string;
  date: Date;
  location: APILocation;

  constructor(data: any) {
    this.id = data.id;
    this.lineId = data.lineId;
    this.stopNumber = data.stopNumber;
    this.type = data.type;
    this.date = data.date;
    this.location = new APILocation(data.location);
  }
}

export class APIOrderLine {
  id: string;
  orderId: string;
  lineNumber: number;
  product: string;
  quantity: number;
  unit: string;
  stops: APIOrderLineStop[];

  constructor(data: any) {
    this.id = data.id;
    this.orderId = data.orderId;
    this.lineNumber = data.lineNumber;
    this.product = data.product;
    this.quantity = data.quantity;
    this.unit = data.unit;
    this.stops = data.stops.map((stop: any) => new APIOrderLineStop(stop));
  }
}

export class APIOrder {
  id: string;
  orderNumber: string | null;
  customerRef: string | null;
  supplierId: number | null;
  customerId: number | null;
  truck: APITruck | null;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  lines: APIOrderLine[];

  // stats
  totalEmptyMeters: number | null = null;
  totalFullMeters: number | null = null;
  totalMeters: number | null = null;
  totalDrivenMeters: number | null = null;
  totalPurchases: number | null = null;
  totalSales: number | null = null;
  wasOwnTrailedUsed: boolean = false;
  date: Date | null = null;

  invoice: APIInvoice | null = null;

  constructor(data: any) {
    this.id = data.id;
    this.orderNumber = data.orderNumber;
    this.customerRef = data.customerRef;
    this.supplierId = data.supplierId;
    this.customerId = data.customerId;
    this.truck = data.supplierTruck ? new APITruck(data.supplierTruck) : data.truck ? new APITruck(data.truck) : null;
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;

    this.lines = data.lines?.map((line: any) => new APIOrderLine(line)) || [];

    this.totalEmptyMeters = data.totalEmptyMeters ?? null;
    this.totalFullMeters = data.totalFullMeters ?? null;
    this.totalMeters = data.totalMeters ?? null;
    this.totalDrivenMeters = data.totalDrivenMeters ?? null;
    this.totalPurchases = data.totalPurchases ?? null;
    this.totalSales = data.totalSales ?? null;
    this.wasOwnTrailedUsed = data.wasOwnTrailedUsed ?? false;
    this.date = data.date ? new Date(data.date) : null;

    this.invoice = data.invoice ? new APIInvoice(data.invoice) : null;
  }
}
